import { ComparatorFn } from "sonobello.utilities.react.mui";

export class CustomDimension<T> {
  id!: T;
  name!: string;

  /** Convert a list of custom dimensions of a primitive id type to an Object with false values for each key.
   * @param dimensions The dimensions that should be transformed into an object.
   * @param defaultValue Optional default value that each resulting object prop value should be set to. Defaults to `false`.
   */
  static toObject<T extends string | number>(dimensions: CustomDimension<T>[], defaultValue = false) {
    return dimensions.reduce((obj, { id }) => {
      obj[id] = defaultValue;
      return obj;
    }, {} as Record<T, boolean>);
  }

  /** A compare function which sorts custom dimensions alphabetically from name from first to last. */
  static NameComparator: ComparatorFn<CustomDimension<unknown>> = (obj1, obj2) =>
    obj1.name > obj2.name ? 1 : obj2.name === obj1.name ? 0 : -1;
}
